module.exports = __webpack_public_path__ + "img/4.ecf0f06f.png";